export const httpMethod = {
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
  GET: 'GET',
  HEAD: 'HEAD',
  JSONP: 'JSONP',
  OPTIONS: 'OPTIONS'
};
